import HelmetTags from "./HelmetTags";

function NotFound() {
  <HelmetTags title="404 Not Found, Please Go to Home Page" />;
  return <div className="w-full h-screen flex justify-center items-center">404 Page Not Found</div>;
}

export default NotFound;
